module.exports = __webpack_public_path__ + "img/twitter.217fccf9.svg";